var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "28", height: "28", viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#clip0_13950_10523)" },
      React.createElement("rect", { width: "28", height: "28", rx: "8", fill: "#FFDA1A" }),
      React.createElement("path", { d: "M14 19.4l3.88 2.455c.71.45 1.58-.215 1.393-1.057l-1.029-4.617 3.432-3.11c.626-.568.29-1.644-.533-1.713l-4.516-.4-1.767-4.364a.92.92 0 0 0-1.72 0l-1.767 4.353-4.516.402c-.822.068-1.159 1.144-.533 1.711l3.431 3.111-1.028 4.618c-.187.84.683 1.506 1.393 1.056L14 19.4z", fill: "#fff" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "clip0_13950_10523" },
        React.createElement("rect", { width: "28", height: "28", rx: "8", fill: "#fff" })
      )
    )
  );
});